import { Box } from '@material-ui/core';
import { PayoutSummary } from '@nemuru-eng/js-api-client';

import { PayoutSummaryConditionsBody } from '@/components/modules/Payouts/PayoutDetails/PayoutDetailsOverview/components/PayoutSummaryConditionsTable/components/PayoutSummaryConditionsBody';
import { PayoutSummaryConditionsHeader } from '@/components/modules/Payouts/PayoutDetails/PayoutDetailsOverview/components/PayoutSummaryConditionsTable/components/PayoutSummaryConditionsHeader';
import { CustomDivider } from '@/components/shared/components/CustomDivider';

interface PayoutSummaryConditionsProps {
  payoutSummary: PayoutSummary;
}

export const PayoutSummaryConditionsTable = ({ payoutSummary }: PayoutSummaryConditionsProps) => {
  return (
    <>
      <Box mt={'12px'}>
        <PayoutSummaryConditionsHeader />
        <CustomDivider my={2} />
        <PayoutSummaryConditionsBody payoutSummary={payoutSummary} />
      </Box>
    </>
  );
};
